<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5498 14.5713C10.5498 13.751 10.6494 13.0977 10.8486 12.6113C11.0479 12.125 11.4126 11.646 11.9429 11.1743C12.4731 10.7026 12.8262 10.3188 13.002 10.0229C13.1777 9.72705 13.2656 9.41504 13.2656 9.08691C13.2656 8.09667 12.8086 7.60156 11.8945 7.60156C11.4609 7.60156 11.1138 7.73486 10.853 8.00146C10.5923 8.26807 10.4561 8.63574 10.4443 9.10449H7.89551C7.90723 7.98535 8.26904 7.10938 8.98096 6.47656C9.69287 5.84375 10.6641 5.52734 11.8945 5.52734C13.1367 5.52734 14.1006 5.82763 14.7861 6.42822C15.4717 7.02881 15.8145 7.87695 15.8145 8.97266C15.8145 9.47071 15.7031 9.94092 15.4805 10.3833C15.2578 10.8257 14.8682 11.3164 14.3115 11.8555L13.5996 12.5322C13.1543 12.96 12.8994 13.4609 12.835 14.0352L12.7998 14.5713H10.5498Z"
      fill="#4B4C52"
    />
    <path
      d="M10.2949 17.2695C10.2949 16.877 10.4282 16.5532 10.6948 16.2983C10.9614 16.0435 11.3027 15.916 11.7188 15.916C12.1348 15.916 12.4761 16.0435 12.7427 16.2983C13.0093 16.5532 13.1426 16.877 13.1426 17.2695C13.1426 17.6563 13.0122 17.9756 12.7515 18.2275C12.4907 18.4795 12.1465 18.6055 11.7188 18.6055C11.291 18.6055 10.9468 18.4795 10.686 18.2275C10.4253 17.9756 10.2949 17.6563 10.2949 17.2695Z"
      fill="#4B4C52"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HelpIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
